import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme/ThemeProvider';
import { useAuth } from '../auth/AuthContext';
import { Eye, EyeOff, RefreshCw } from 'lucide-react';
import FallingStarLogo from '../theme/FallingStarLogo';
import Navbar from '../components/Navbar';
import { ScaleIn } from '../components/ScrollReveal';

export default function LoginPage() {
  const { t, glassCard, glassInput, iri } = useTheme();
  const { login, sessionExpired } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) { setError('All fields are required'); return; }
    setLoading(true);
    try {
      const res = await login(email, password);
      if (res.success) navigate(res.user?.fitness_only ? '/fitness' : '/dashboard');
      else setError(res.message || 'Invalid credentials');
    } catch { setError('Connection failed'); }
    setLoading(false);
  };

  return (
    <>
      <Navbar />
      <div style={{ minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', zIndex: 1 }}>
        <ScaleIn><div style={{ ...glassCard, padding: 40, width: '100%', maxWidth: 420 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <FallingStarLogo size={48} />
            </div>
            <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 6 }}>Welcome back</h1>
            <p style={{ fontSize: 13, color: t.textMuted }}>Sign in to your account</p>
          </div>

          {sessionExpired && !error && (
            <div style={{
              background: t.badgeExecBg, border: `1px solid ${t.badgeExecBorder}`, borderRadius: 10,
              padding: '10px 14px', marginBottom: 20, fontSize: 13, lineHeight: 1.45, color: t.badgeExecText,
            }}>
              Je sessie is verlopen. Log opnieuw in om verder te gaan.
            </div>
          )}

          {error && (
            <div style={{ background: 'rgba(244,63,94,0.1)', border: '1px solid rgba(244,63,94,0.2)', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: 13, color: t.negative }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: t.textDim, display: 'block', marginBottom: 6 }}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={glassInput} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: t.textDim, display: 'block', marginBottom: 6 }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" style={{ ...glassInput, paddingRight: 40 }} />
                <button type="button" onClick={() => setShowPw(!showPw)} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: t.textFaint, cursor: 'pointer' }}>
                  {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
                </button>
              </div>
            </div>


            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px 0', borderRadius: 12, border: 'none', cursor: loading ? 'wait' : 'pointer',
              background: iri, color: '#fff', fontSize: 14, fontWeight: 700,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, transition: 'opacity 0.2s',
              opacity: loading ? 0.7 : 1, boxShadow: '0 14px 30px rgba(111,168,255,0.20)',
            }}>
              {loading && <RefreshCw size={14} style={{ animation: 'spin 1s linear infinite' }} />}
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: t.textFaint }}>
            Registration is currently invite-only
          </p>
        </div></ScaleIn>
      </div>
    </>
  );
}
